import React, { Component } from 'react';
import FakeData from '../../fake-data';
import { Link } from 'react-router-dom';
import { Helmet, Redirect } from "react-helmet";
import './TournamentInit.css';
import { ItemPicker, Modal, PhonePicker } from '../../components/Common';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { LocationPicker } from '../../components/Event';

export default class TournamentInit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tourn: {
                name: "",
                sport: "",
                id: null,
                hash: null,
                level: "",
                type: "",
                email: "",
                phone: "",
                land: "",
                gender: "",
                website: "",
                location: "",
                address: "",
                suburb: "",
                postal: "",
                state: "",
                country: "",
                teams: [],
                socials: [],
                established: "",
                manager: { id: null, name: "" },
                secretary: { id: null, name: "" },
                about: "",
                roles: [],
                settings: []
            },
            yourRole: {
                role: ""
            },
            confirmee: {
                name: "",
                email: ""
            },
            othersVerifications: [],
            levels: ["Amatuer", "Professional", "Semi-Professional"],
            types: [
                "league",
                "group_knockout",
                "knockout"
            ],
            genders: ["male", "female", "mixed"],
            roles: ["President", "Vice President", "Secretary", "Governing Body", "Council Memeber", "Public Relations", "Finance", "General Administration", "Executive Committee", "Chairman", "Vice Chairman"],
            isAddingSports: false,
            isAddingTeams: false,
            isAddingPersons: false,
            canAddTeams: false,
            isAfterReg: false,
            phoneErr: false,
            landErr: false,
            isSet: true
        }
    }

    componentWillMount() {
        if (FakeData.getData("tournamentStore")) {
            const data = FakeData.getData("tournamentStore");
            this.state.tourn.name = data.name;
            this.state.tourn.sport = data.sport;
            this.state.tourn.type = data.sport;

            this.setState({
                tourn: this.state.tourn,
                isSet: true
            });
        } else {
            //this.setState({ isSet: false });
        }
    }

    onPhoneChange(num, err) {
        this.state.tourn.phone = num
        this.setState({ tourn: this.state.tourn, phoneErr: err });
    }

    onLandlineChange(num, err) {
        this.state.tourn.land = num
        this.setState({ tourn: this.state.tourn, landErr: err });
    }

    save() {
        const tourn = this.state.tourn;

        if (tourn.name === "") {
            this.setState({ nameErr: true });
            return;
        }

        if (tourn.level === "") {
            this.setState({ levelErr: true });
            return;
        }

        if (this.state.yourRole.role === "") {
            this.setState({ roleErr: true });
            return;
        }

        if (tourn.email === "" || !FakeData.isEmail(tourn.email)) {
            this.setState({ emailErr: true });
            return;
        }

        if (tourn.phone === "" || this.state.phoneErr) {
            this.setState({ phoneErr: true });
            return;
        }

        if (tourn.land === "" || this.state.landErr) {
            this.setState({ landErr: true });
            return;
        }

        if (tourn.website === "" || !FakeData.isWebsite(tourn.website)) {
            this.setState({ webErr: true });
            return;
        }

        if (tourn.sport === "") {
            this.setState({ sportErr: true });
            return;
        }

        if (tourn.type === "") {
            this.setState({ typeErr: true });
            return;
        }

        if (tourn.gender === "") {
            this.setState({ genderErr: true });
            return;
        }

        if (tourn.address === "") {
            this.setState({ addressErr: true });
            return;
        }

        if (tourn.suburb === "") {
            this.setState({ suburbErr: true });
            return;
        }

        if (tourn.location === "") {
            this.setState({ locationErr: true });
            return;
        }

        if (tourn.postal === "") {
            this.setState({ postalErr: true });
            return;
        }

        if (tourn.country === "") {
            this.setState({ countryErr: true });
            return;
        }

        if (tourn.state === "") {
            this.setState({ stateErr: true });
            return;
        }

        if (tourn.manager.id === null) {
            this.setState({ managerErr: true });
            return;
        }

        if (tourn.secretary.id === null) {
            this.setState({ secretaryErr: true });
            return;
        }

        if (this.state.confirmee.name === "") {
            this.setState({ confirmeeNameErr: true });
            return;
        }

        if (this.state.confirmee.email === "" || !FakeData.isEmail(this.state.confirmee.email)) {
            this.setState({ confirmeeEmailErr: true });
            return;
        }

        const others = this.state.othersVerifications

        /*if ((this.state.yourRole.role === "Admin" || this.state.yourRole.role === "Staff") && (this.state.othersVerifications.length === 0)) {
            //console.log(this.state.yourRole.role, this.state.othersVerifications.length)
            this.setState({ needRoles: false });
        } else {
            this.setState({ needRoles: true });
            return;
        }*/

        let bool = false;
        for (let x = 0; x < others.length; x++) {
            let item = others[x];
            if (item.name === "") {
                item.nameError = true;
                this.setState({ othersVerifications: others });
                bool = true;
            }

            if (item.email === "" || !FakeData.isEmail(item.email)) {
                item.emailErr = true;
                this.setState({ othersVerifications: others });
                bool = true;
            }
        }

        if (bool) {
            return;
        }

        const _that = this;
        tourn['username'] = tourn.name.replace(" ","_").toLowerCase();
        this.setState({ tourn: tourn });

        const dataTo = {
            tourn: tourn,
            confirmee: this.state.confirmee,
            role: this.state.yourRole,
            otherPeople: others,
            user: FakeData.getData("yoo")
        }

        console.log(dataTo)
        //createTournament
        FakeData.post("/createTournament.php?auth0", dataTo, {
            success: ((res) => {
                //console.log(res)
                if (res.error) {
                    FakeData.alert("An tournament with the email or name provided already exists!");
                    _that.setState({ emailErr: true });
                } else {
                    _that.state.tourn.id = res.id;
                    _that.state.tourn.hash = res.hash;
                    _that.setState({ isAfterReg: true, tourn: _that.state.tourn });
                }
            }),
            error: ((err) => {

            })
        }, true, "Tournament was created!", ((e) => { }))
    }

    render() {
        const { isSet } = this.state
        if (!isSet) {
            return (
                <Redirect to={{ pathname: "/create" }} />
            )
        }
        return (
            <div className="full-screen-page">
                {!this.state.isAfterReg &&
                    <div className="after-register-profile" style={{ width: "85%" }}>
                        <div className="after-register-profile-content">
                            <div className="after-register-profile-content-head">
                                <img src="images/add_blu.svg" />
                                <h1>Tournament Profile</h1>
                            </div>
                            <div className="after-register-profile-content-body">
                                <div className="register-profile-content-body-item">
                                    <h2>Tournament Details</h2>
                                    <div>
                                        <input placeholder="Tournament Name" className={(this.state.nameErr) ? "error" : ""} value={this.state.tourn.name} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.tourn.name = val;
                                            this.setState({ tourn: this.state.tourn, nameErr: false });
                                        }} />
                                        <select className={(this.state.levelErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.tourn.level = val;
                                            this.setState({ tourn: this.state.tourn, levelErr: false });
                                        }} value={this.state.tourn.level}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Tournament professional level?</option>
                                            {
                                                this.state.levels.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <select className={(this.state.roleErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.yourRole.role = val;
                                            this.setState({ yourRole: this.state.yourRole, roleErr: false });
                                        }} value={this.state.yourRole.role}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>What is your role in the tournament?</option>
                                            {
                                                this.state.roles.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <div className="register-input">
                                            <img src="images/email_icon_blu.svg" />
                                            <input className={(this.state.emailErr) ? "error" : ""} placeholder="tournamentname@tournamentwebsite.com" value={this.state.tourn.email} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.tourn.email = val;
                                                this.setState({ tourn: this.state.tourn, emailErr: !FakeData.isEmail(val) });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/mobile_icon_blu.svg" />
                                            <PhonePicker className={(this.state.phoneErr) ? "error" : ""} value={this.state.tourn.phone} onChange={this.onPhoneChange.bind(this)} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/landline_icon_blu.svg" />
                                            <PhonePicker className={(this.state.landErr) ? "error" : ""} value={this.state.tourn.land} onChange={this.onLandlineChange.bind(this)} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/website_icon_blu.svg" />
                                            <input className={(this.state.webErr) ? "error" : ""} placeholder="www.tournamentwebsite.com" value={this.state.tourn.website} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.tourn.website = val;
                                                this.setState({ tourn: this.state.tourn, webErr: !FakeData.isWebsite(val) });
                                            }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="register-profile-content-body-item">
                                    <h2>Information</h2>
                                    <div>
                                        <select className={(this.state.sportErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.tourn.sport = val;
                                            this.setState({ tourn: this.state.tourn, sportErr: false });
                                        }} value={this.state.tourn.sport}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Select sport</option>
                                            {
                                                FakeData.listify(FakeData.getData("all_sports")).map((item, i) => {
                                                    return (
                                                        <option value={item.name} key={i} style={{ padding: "10px" }}>{item.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <select className={(this.state.typeErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.tourn.type = val;
                                            this.setState({ tourn: this.state.tourn, typeErr: false });
                                        }} value={this.state.tourn.type}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Select type</option>
                                            {
                                                this.state.types.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item.replace("_", " ").capitalize()}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <select className={(this.state.genderErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.tourn.gender = val;
                                            this.setState({ tourn: this.state.tourn, genderErr: false });
                                        }} value={this.state.tourn.gender}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Select gender</option>
                                            {
                                                this.state.genders.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item.capitalize()}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <div className="register-input">
                                            <img src="images/location_icon.svg" />
                                            <input className={(this.state.addressErr) ? "error" : ""} placeholder="Address" value={this.state.tourn.address} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.tourn.address = val;
                                                this.setState({ tourn: this.state.tourn, addressErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input className={(this.state.suburbErr) ? "error" : ""} placeholder="Suburb" value={this.state.tourn.suburb} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.tourn.suburb = val;
                                                this.setState({ tourn: this.state.tourn, suburbErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input className={(this.state.locationErr) ? "error" : ""} placeholder="City" value={this.state.tourn.location} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.tourn.location = val;
                                                this.setState({ tourn: this.state.tourn, locationErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input type="number" max="99999" className={(this.state.postalErr) ? "error" : ""} placeholder="Postal Code" value={this.state.tourn.postal} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.tourn.postal = val;
                                                this.setState({ tourn: this.state.tourn, postalErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <CountryDropdown classes={(this.state.countryErr) ? "select-input error" : "select-input"}
                                                value={this.state.tourn.country}
                                                onChange={(val) => {
                                                    this.state.tourn.country = val;
                                                    this.setState({ tourn: this.state.tourn, countryErr: false });
                                                }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <RegionDropdown classes={(this.state.stateErr) ? "select-input error" : "select-input"}
                                                country={this.state.tourn.country}
                                                value={this.state.tourn.state}
                                                onChange={(val) => {
                                                    this.state.tourn.state = val;
                                                    this.setState({ tourn: this.state.tourn, stateErr: false });
                                                }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="register-profile-content-body-item">
                                    <h2>Tournament Management</h2>
                                    <div>
                                        <ItemPicker label="Tournament Chairman/President" user={FakeData.getData("yoo")} error={this.state.managerErr} onSelectedItem={(user) => {
                                            this.state.tourn.manager = user;
                                            this.setState({ tourn: this.state.tourn, managerErr: false });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                        <br />
                                        <ItemPicker label="Tournament Vice Chairman/President" user={FakeData.getData("yoo")} error={this.state.secretaryErr} onSelectedItem={(user) => {
                                            this.state.tourn.secretary = user;
                                            this.setState({ tourn: this.state.tourn, secretaryErr: false });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                    </div>
                                    <h2>Confirmation</h2>
                                    <div>
                                        <p>To Confirm that <b>{(this.state.tourn.name === "") ? "this tournament" : this.state.tourn.name}</b> does exist please enter at least one person’s name from one of the sports teams that make up the teams at the tournament.</p>
                                        <input className={(this.state.confirmeeNameErr) ? "error" : ""} placeholder="Name" value={this.state.confirmee.name} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.confirmee.name = val;
                                            this.setState({ confirmee: this.state.confirmee, confirmeeNameErr: false });
                                        }} />
                                        <div className="register-input">
                                            <img src="images/email_icon_blu.svg" />
                                            <input className={(this.state.confirmeeEmailErr) ? "error" : ""} placeholder="name@example.com" value={this.state.confirmee.email} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.confirmee.email = val;
                                                this.setState({ confirmee: this.state.confirmee, confirmeeEmailErr: !FakeData.isEmail(val) });
                                            }} />
                                        </div>
                                        <p className={this.state.needRoles ? "error" : ""}>If you have selected your role as <b>Tournament Manager, Coach, Referee or Score keeper</b> you will need to be verified by an additional person. This is important, non-verification of your role will mean you cannot create games or access the Game Management console (GMC).</p>
                                        <div>
                                            {
                                                this.state.othersVerifications.map((item, i) => {
                                                    return (
                                                        <div key={i} className="verify-input">
                                                            <input placeholder="Name" className={(item.nameError) ? "error" : ""} value={item.name} onChange={(e) => {
                                                                const val = e.target.value
                                                                item.name = val;
                                                                item.nameError = false
                                                                this.setState({ othersVerifications: this.state.othersVerifications });
                                                            }} />
                                                            <div className="register-input">
                                                                <img src="images/email_icon_blu.svg" />
                                                                <input className={(item.emailErr) ? "error" : ""} placeholder="name@example.com" value={item.email} onChange={(e) => {
                                                                    const val = e.target.value
                                                                    item.email = val;
                                                                    item.emailErr = !FakeData.isEmail(val)
                                                                    this.setState({ othersVerifications: this.state.othersVerifications });
                                                                }} />
                                                                <i className="material-icons" onClick={() => {
                                                                    this.state.othersVerifications.splice(i, 1)
                                                                    this.setState({ othersVerifications: this.state.othersVerifications });
                                                                }}>delete</i>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className="profile_add_item_alt" onClick={() => {
                                            if ((this.state.yourRole.role === "Admin" || this.state.yourRole.role === "Staff" || this.state.yourRole.role === "")) {
                                                return;
                                            } else if ((this.state.othersVerifications[this.state.othersVerifications.length - 1] && (this.state.othersVerifications[this.state.othersVerifications.length - 1].name === "" || this.state.othersVerifications[this.state.othersVerifications.length - 1].email === ""))) {
                                                return
                                            }
                                            this.state.othersVerifications.push({ name: "", nameError: false, email: "", emailErr: false })
                                            this.setState({ othersVerifications: this.state.othersVerifications, needRoles: false });
                                        }}>Add a verification contact</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div tabIndex="0" className="after-register-profile-button gbl-btn" onClick={this.save.bind(this)}>Save Profile</div>
                    </div>
                }
                {this.state.isAfterReg &&
                    <div className="after-register-profile" style={{ width: "85%" }}>
                        <div className="after-reg">
                            <h3>Tournament page created successfully!</h3>
                            <Link  to={{ pathname: "/tournament/" + this.state.tourn.username, search: '?sInit=about' }}>Continue to Tournament Page</Link>
                        </div>
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/CreatePages/TournamentInit.jsx